<template>
  <div>
    <div class="selectPackage white" v-if="flow">
      <div style="overflow: hidden">
        <v-row justify="center" class="mt-5" v-if="$vuetify.breakpoint.mdAndUp">
          <v-col cols="10">
            <div>
              <v-row class="mt-5">
                <v-col cols="12" lg="3" class="">
                  <DoctorSideBarPayment @backToTime="backToTime" :selected_time="selected_time" :therapist="therapist"/>
                </v-col>
                <v-col cols="12" lg="9" class="">

                  <!--                  <div class="hintArea">-->
                  <!--                    <div class="titleHintArea d-flex">-->
                  <!--                      <div>-->
                  <!--                        <img src="../../assets/image/user-journey/checkbox.svg" alt="">-->
                  <!--                      </div>-->
                  <!--                      <div class="mr-2">-->
                  <!--                        ویژگی های برگزاری جلسات با تیم سیمیاروم-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                  <!--                    <div class="contentHint">-->
                  <!--                      <v-row class="pa-0 ma-0 mt-4">-->
                  <!--&lt;!&ndash;                        <v-col cols="12" class="ma-0 pa-0" lg="6">&ndash;&gt;-->
                  <!--&lt;!&ndash;                          <div class="hintItem d-flex">&ndash;&gt;-->
                  <!--&lt;!&ndash;                            <img src="../../assets/image/user-journey/check.svg" alt="">&ndash;&gt;-->
                  <!--&lt;!&ndash;                            <div class="mr-2">&ndash;&gt;-->
                  <!--&lt;!&ndash;                              <b>&ndash;&gt;-->
                  <!--&lt;!&ndash;                                بازگشت تمام وجه&ndash;&gt;-->
                  <!--&lt;!&ndash;                              </b>&ndash;&gt;-->
                  <!--&lt;!&ndash;                              در صورت عدم رضایت، بعد از جلسه اول&ndash;&gt;-->
                  <!--&lt;!&ndash;                            </div>&ndash;&gt;-->
                  <!--&lt;!&ndash;                          </div>&ndash;&gt;-->
                  <!--&lt;!&ndash;                        </v-col>&ndash;&gt;-->
                  <!--                        <v-col cols="12" class="ma-0 pa-0" lg="4">-->
                  <!--                          <div class="hintItem d-flex">-->
                  <!--                            <img src="../../assets/image/user-journey/check.svg" alt="">-->
                  <!--                            <div class="mr-2">-->
                  <!--                              بررسی اثربخشی جلسات به صورت مستمر-->
                  <!--                            </div>-->
                  <!--                          </div>-->
                  <!--                        </v-col>-->
                  <!--                        <v-col cols="12" class="ma-0 pa-0" lg="4">-->
                  <!--                          <div class="hintItem d-flex">-->
                  <!--                            <img src="../../assets/image/user-journey/check.svg" alt="">-->
                  <!--                            <div class="mr-2">-->
                  <!--                              همراهی تیم تخصصی ارزیابی جلسات-->
                  <!--                            </div>-->
                  <!--                          </div>-->
                  <!--                        </v-col>-->
                  <!--                        <v-col cols="12" class="ma-0 pa-0" lg="4">-->
                  <!--                          <div class="hintItem d-flex">-->
                  <!--                            <img src="../../assets/image/user-journey/check.svg" alt="">-->
                  <!--                            <div class="mr-2">-->
                  <!--                              امکان تغییر تراپیست-->
                  <!--                            </div>-->
                  <!--                          </div>-->
                  <!--                        </v-col>-->
                  <!--                      </v-row>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <div class="blueHint">
                    <div class="d-flex align-center blueHint__message">
                      <div>
                        <img src="../../assets/image/user-journey/info-circle.png" alt="">
                      </div>
                      <div class="mr-2">
                        زمان و تراپیست انتخاب شده تا
                        <b>یک ساعت</b>
                        برای شما محفوظ خواهد ماند.
                      </div>
                    </div>
                    <div v-if="hasAppliedDiscount" class="blueHint__applied mt-2 d-flex align-center justify-space-between flex-wrap">
                      <span>
                        کد تخفیف <b>{{ discount_code }}</b> اعمال شد
                        <template v-if="appliedDiscountAmount">
                          ({{ withCurrency(appliedDiscountAmount.amount, appliedDiscountAmount.currency, 'long') }} تخفیف)
                        </template>
                      </span>
                      <v-btn x-small text color="#035184" @click="clearDiscount">حذف</v-btn>
                    </div>
                  </div>
                  <div class="contentPresession mt-5 mb-10">
                    <b>
                      برای تکمیل رزرو جلسه‌تان، لطفاً پکیج موردنظر را از بین گزینه‌های زیر انتخاب و پرداخت کنید.
                    </b>
                  </div>
                  <div class="packageArea ">
                    <v-row v-if="hasPackages">
                      <v-col cols="12" lg="6" v-for="(item,i) in packagesList" :key="i">
                        <div class="oldUserPackage fill-height  d-flex flex-column">
                          <div class="d-flex justify-space-between">
                            <div class="titlePackage">
                              {{item.title}}
                            </div>
                            <div>
                            </div>
                          </div>
                          <v-spacer></v-spacer>
                          <div class="priceBox">
                            <div class="d-flex align-center flex-wrap">
                              <div
                                  v-if="getPackagePriceInfo(item).hasDiscount"
                                  class="oldPrice ml-3"
                              >
                                {{
                                  withCurrency(
                                      getPackagePriceInfo(item).original,
                                      getPackagePriceInfo(item).currency,
                                      'long'
                                  )
                                }}
                              </div>
                              <div class="newPrice">
                                {{
                                  withCurrency(
                                      getPackagePriceInfo(item).final,
                                      getPackagePriceInfo(item).currency,
                                      'long'
                                  )
                                }}
                              </div>
                              <div class="perSession d-flex flex-column justify-center mr-5">
                                <div>/ جلسه</div>
                              </div>
                            </div>
                          </div>
                          <div class="">
                            <v-btn
                                outlined
                                color="primary"
                                class="submitBtnOutline"
                                elevation="0"
                                @click="selectPackage(item.id)"
                            >
                              خرید بسته
                            </v-btn>
                            <div class="refund">
                              <b>
                                بازگشت تمام وجه
                              </b>
                              در صورت عدم رضایت، بعد از جلسه اول
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                    <div v-else-if="packagesList === null" class="text-center pa-10">
                      <div>در حال بارگذاری پکیج‌ها...</div>
                    </div>
                    <div v-else class="text-center pa-10">
                      <div>پکیجی یافت نشد</div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-col>

        </v-row>
        <div class="mobileArea " v-else>
          <DoctorSideBarPayment @backToTime="backToTime" :selected_time="selected_time" :therapist="therapist"/>
          <div class="whiteBox">
            <div class="blueHint mb-4">
              <div class="d-flex align-center blueHint__message">
                <div>
                  <img src="../../assets/image/user-journey/info-circle.png" alt="">
                </div>
                <div class="mr-2">
                  زمان و تراپیست انتخاب شده تا
                  <b>یک ساعت</b>
                  برای شما محفوظ خواهد ماند.
                </div>
              </div>
              <div v-if="hasAppliedDiscount" class="blueHint__applied mt-2 d-flex align-center justify-space-between flex-wrap">
                <span>
                  کد تخفیف <b>{{ discount_code }}</b> اعمال شد
                  <template v-if="appliedDiscountAmount">
                    ({{ withCurrency(appliedDiscountAmount.amount, appliedDiscountAmount.currency, 'long') }} تخفیف)
                  </template>
                </span>
                <v-btn x-small text color="#035184" @click="clearDiscount">حذف</v-btn>
              </div>
            </div>
            <div class="hintArea">
              <div class="contentHint">
                <v-row class="pa-0 ma-0 ">
                  <v-col cols="12" class="ma-0 pa-0" lg="6">
                    <div class="hintItem d-flex">
                      <img src="../../assets/image/user-journey/check.svg" alt="">
                      <div class="mr-2">
                        <b>
                          بازگشت تمام وجه
                        </b>
                        در صورت عدم رضایت، بعد از جلسه اول
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" class="ma-0 pa-0" lg="6">
                    <div class="hintItem d-flex">
                      <img src="../../assets/image/user-journey/check.svg" alt="">
                      <div class="mr-2">
                        بررسی اثربخشی جلسات به صورت مستمر
                      </div>
                    </div>


                  </v-col>

                </v-row>
              </div>
            </div>
            <div>
              <div class="packageArea ">
                <v-row v-if="hasPackages">
                  <v-col cols="12" lg="6" v-if="multiSessionPackage">
                    <div class="newUserPackage">
                      <div class="d-flex justify-space-between">
                        <div class="titlePackage">
                          {{
                            multiSessionPackage.title || `بسته ${multiSessionPackage.session_count}جلسه ای شروع مسیر`
                          }}
                        </div>
                        <div>
                        </div>
                      </div>
                      <div class="priceBox">
                        <div class="d-flex align-center flex-wrap">
                          <div
                              v-if="getPackagePriceInfo(multiSessionPackage).hasDiscount"
                              class="oldPrice ml-3"
                          >
                            {{
                              withCurrency(
                                  getPackagePriceInfo(multiSessionPackage).original,
                                  getPackagePriceInfo(multiSessionPackage).currency,
                                  'long'
                              )
                            }}
                          </div>
                          <div class="newPrice">
                            {{
                              withCurrency(
                                  getPackagePriceInfo(multiSessionPackage).final,
                                  getPackagePriceInfo(multiSessionPackage).currency,
                                  'long'
                              )
                            }}
                          </div>
                          <div class="perSession d-flex flex-column justify-center mr-5"
                               v-if="multiSessionPackage.single_session_price">
                            <div>
                                  <span class="enFont">
                                    {{
                                      withCurrency(multiSessionPackage.single_session_price, multiSessionPackage.currency || 'rial')
                                    }}
                                  </span>
                              / به ازای هر جلسه
                            </div>
                          </div>
                        </div>
                        <div class="">
                          <v-btn
                              color="primary"
                              class="submitBtn"
                              elevation="0"
                              @click="selectPackage(multiSessionPackage.id)"
                          >
                            خرید بسته
                          </v-btn>
                          <div class="refund">
                            <b>
                              بازگشت تمام وجه
                            </b>
                            در صورت عدم رضایت، بعد از جلسه اول
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" lg="6" v-if="singleSessionPackage">
                    <div class="oldUserPackage fill-height  d-flex flex-column">
                      <div class="d-flex justify-space-between">
                        <div class="titlePackage">
                          {{ singleSessionPackage.title || 'یک جلسه مشاوره' }}
                        </div>
                        <div>
                        </div>
                      </div>
                      <v-spacer></v-spacer>
                      <div class="priceBox">
                        <div class="d-flex align-center flex-wrap">
                          <div
                              v-if="getPackagePriceInfo(singleSessionPackage).hasDiscount"
                              class="oldPrice ml-3"
                          >
                            {{
                              withCurrency(
                                  getPackagePriceInfo(singleSessionPackage).original,
                                  getPackagePriceInfo(singleSessionPackage).currency,
                                  'long'
                              )
                            }}
                          </div>
                          <div class="newPrice">
                            {{
                              withCurrency(
                                  getPackagePriceInfo(singleSessionPackage).final,
                                  getPackagePriceInfo(singleSessionPackage).currency,
                                  'long'
                              )
                            }}
                          </div>
                          <div class="perSession d-flex flex-column justify-center mr-5">
                            <div>/ جلسه</div>
                          </div>
                        </div>
                      </div>
                      <div class="">
                        <v-btn
                            outlined
                            color="primary"
                            class="submitBtnOutline"
                            elevation="0"
                            @click="selectPackage(singleSessionPackage.id)"
                        >
                          خرید بسته
                        </v-btn>
                        <div class="refund">
                          <b>
                            بازگشت تمام وجه
                          </b>
                          در صورت عدم رضایت، بعد از جلسه اول
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <div v-else-if="packagesList === null" class="text-center pa-10">
                  <div>در حال بارگذاری پکیج‌ها...</div>
                </div>
                <div v-else class="text-center pa-10">
                  <div>پکیجی یافت نشد</div>
                </div>
              </div>
              <!--                <div class="text-center mt-8">-->
              <!--                  <img src="../../assets/image/user-journey/hipa.png" alt="">-->
              <!--                </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--      <PreSessionBox text="اگر همچنان سوال یا ابهامی در مسیر انتخاب تراپیست دارید، کارشناسان ما همراه شما هستند"-->
    <!--                     class="mt-15"/>-->

    <v-dialog
        v-if="$vuetify.breakpoint.mdAndUp"
        v-model="packageModal"
        max-width="440"
        persistent
        content-class="discount-modal-dialog"
    >
      <v-card class="discount-modal">
        <v-btn icon small class="discount-modal__close" @click="closePackageModal">
          <v-icon size="20">mdi-close</v-icon>
        </v-btn>
        <v-card-text class="discount-modal__body">
          <div class="discount-modal__header">
            <div class="discount-modal__icon">
              <v-icon color="#39C990" size="28">mdi-ticket-percent-outline</v-icon>
            </div>
            <div class="discount-modal__titles">
              <h3 class="discount-modal__title">کد تخفیف</h3>
              <p class="discount-modal__desc">کد تخفیف خود را وارد کنید.</p>
            </div>
          </div>
          <v-text-field
              v-model.trim="discount_code"
              outlined
              hide-details="auto"
              placeholder="کد تخفیف"
              color="#39C990"
              class="discount-modal__input"
              dir="ltr"
              :error-messages="discountError"
              :disabled="packageModalLoading"
              @input="discountError = ''"
              @keypress.native.enter="confirmDiscountModal"
          />
          <div class="discount-modal__actions">
            <v-btn
                class="discount-modal__btn discount-modal__btn--outline"
                elevation="0"
                :disabled="packageModalLoading"
                @click="closePackageModal"
            >
              انصراف
            </v-btn>
            <v-btn
                class="discount-modal__btn discount-modal__btn--primary"
                elevation="0"
                :loading="packageModalLoading"
                @click="confirmDiscountModal"
            >
              ثبت کد تخفیف
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-bottom-sheet
        v-else
        v-model="packageModal"
        scrollable
        app
        content-class="discount-modal-sheet"
    >
      <v-card class="discount-modal discount-modal--sheet">
        <div class="discount-modal__handle"></div>
        <v-btn icon small class="discount-modal__close" @click="closePackageModal">
          <v-icon size="20">mdi-close</v-icon>
        </v-btn>
        <v-card-text class="discount-modal__body">
          <div class="discount-modal__header">
            <div class="discount-modal__icon">
              <v-icon color="#39C990" size="28">mdi-ticket-percent-outline</v-icon>
            </div>
            <div class="discount-modal__titles">
              <h3 class="discount-modal__title">کد تخفیف</h3>
              <p class="discount-modal__desc">کد تخفیف خود را وارد کنید.</p>
            </div>
          </div>
          <v-text-field
              v-model.trim="discount_code"
              outlined
              hide-details="auto"
              placeholder="کد تخفیف"
              color="#39C990"
              class="discount-modal__input"
              dir="ltr"
              :error-messages="discountError"
              :disabled="packageModalLoading"
              @input="discountError = ''"
              @keypress.native.enter="confirmDiscountModal"
          />
          <div class="discount-modal__actions discount-modal__actions--stacked">
            <v-btn
                class="discount-modal__btn discount-modal__btn--primary"
                block
                elevation="0"
                :loading="packageModalLoading"
                @click="confirmDiscountModal"
            >
              ثبت کد تخفیف
            </v-btn>
            <v-btn
                class="discount-modal__btn discount-modal__btn--outline"
                block
                text
                elevation="0"
                @click="closePackageModal"
            >
              انصراف
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>

  </div>
</template>

<script>
import moment from 'moment-timezone';
import momentJalali from "moment-jalaali";
import {mapGetters} from "vuex";
import DoctorSideBarPayment from "@/components/UserJourney/DoctorSideBarPayment.vue";
import PreSessionBox from "@/components/UserJourney/PreSessionBox.vue";
import EventsMixins from "@/mixins/EventsMixins";
/*eslint-disable*/
export default {
  mixins: [EventsMixins],
  components: {PreSessionBox, DoctorSideBarPayment},
  props: {
    therapist: Object,
    flow: Object,
    selected_time: Object,
  },
  computed: {
    ...mapGetters({
      'profile': 'getProfile',
    }),
    multiSessionPackage() {
      if (!this.packagesList || this.packagesList.length === 0) return null
      return this.packagesList.find(pkg => pkg.session_count && pkg.session_count > 1) || null
    },
    singleSessionPackage() {
      if (!this.packagesList || this.packagesList.length === 0) return null
      return this.packagesList.find(pkg => pkg.session_count === 1) || (this.packagesList.length > 1 ? this.packagesList[1] : null)
    },
    hasPackages() {
      return this.packagesList && this.packagesList.length > 0
    },
    hasAppliedDiscount() {
      return !!(this.discountValidation && this.discountValidation.valid && this.discount_code)
    },
    appliedDiscountAmount() {
      if (!this.discountValidation) return null
      const preview = this.discountValidation.preview
      if (preview && preview.estimated_discount != null) {
        return {
          amount: preview.estimated_discount,
          currency: preview.currency || 'rial',
        }
      }
      const coupon = this.discountValidation.coupon
      if (coupon && coupon.amount_irr != null) {
        return {
          amount: coupon.amount_irr,
          currency: 'rial',
        }
      }
      return null
    },
  },
  data() {
    return {
      packageModal: false,
      packageModalLoading: false,
      discount_code: '',
      discountValidation: null,
      discountError: '',
      segment: null,
      packagesList: null,
      packages: {
        // pricing_A: {
        //   id: 325,
        //   price: '35',
        // },
        pricing_A: {
          id: 326,
          price: '39.95',
        },
        pricing_B: {
          id: 327,
          price: '45',
        },
        pricing_C: {
          id: 68,
          price: '49.95',
        },
      }
    }
  },
  methods: {
    getFlowDetail() {
      this.$emitEvent('setLoading', true)
      this.requesting('setSession', 'getFlowDetail', {}, {
        token: localStorage.getItem('set_session_token')
      }).then((resp) => {
        this.segment = this.packages[resp.data.flow.ab_variant ?? 'pricing_C']
      }).catch((error) => {
        const status = error && error.response && error.response.status
        const payload = error && error.response && error.response.data
        const errorCode = payload && payload.data && payload.data.error_code
        if (status === 403 || errorCode === 'FLOW_OWNERSHIP_MISMATCH' || status === 400) {
          this.$emit('restartTest')
        }
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    tryGetPackagesByGrade() {
      if (!this.therapist) {
        console.warn('Therapist not available')
        return
      }

      // Check for grade in different possible locations
      const grade = this.therapist.grade


      if (grade) {
        console.log('Found grade, calling getPackagesByGrade:', grade)
        this.getPackagesByGrade()
      } else {
        console.warn('Grade not found in therapist object. Therapist structure:', this.therapist)
        // Try to get packages anyway after a short delay in case therapist is still loading
        setTimeout(() => {
          const delayedGrade = this.therapist?.grade ||
              this.therapist?.user?.grade ||
              this.therapist?.doctor?.grade ||
              this.therapist?.user?.doctor?.grade
          if (delayedGrade) {
            console.log('Found grade after delay, calling getPackagesByGrade:', delayedGrade)
            this.getPackagesByGrade()
          }
        }, 500)
      }
    },
    getPackagesByGrade() {
      console.log('getPackagesByGrade called', {therapist: this.therapist})

      if (!this.therapist) {
        console.warn('Therapist not available')
        return
      }

      // Check for grade in different possible locations
      const grade = this.therapist.grade ||
          this.therapist.user?.grade ||
          this.therapist.doctor?.grade ||
          this.therapist.user?.doctor?.grade

      if (!grade) {
        console.warn('Grade not available in therapist object:', this.therapist)
        return
      }

      console.log('Calling API with grade:', grade)
      this.$emitEvent('setLoading', true)
      this.requesting('packages', 'getPackagesByGrade', {}, {
        grade: grade
      }).then((resp) => {
        console.log('Packages response:', resp)
        this.packagesList = resp.data.packages || []
      }).catch((error) => {
        console.error('Error fetching packages by grade:', error)
        this.packagesList = []
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    backToTime() {
      this.$emit('backToTime')
    },
    parseDiscountApiResponse(resp) {
      if (!resp) {
        return {root: {}, payload: {}}
      }

      // axios response: { data: { status_code, type, data: {...} } }
      if (resp.data && (resp.data.type || resp.data.status_code != null)) {
        return {
          root: resp.data,
          payload: resp.data.data || {},
        }
      }

      // unwrapped API body from httpUtilities: { status_code, type, data: {...} }
      if (resp.type || resp.status_code != null) {
        return {
          root: resp,
          payload: resp.data || {},
        }
      }

      return {root: {}, payload: resp}
    },
    getDiscountRequestBody(code) {
      const body = {discount_code: code}
      const token = localStorage.getItem('set_session_token')
      if (token) {
        body.token = token
      }
      return body
    },
    getDiscountErrorMessage(root, payload) {
      if (root && root.message) {
        return root.message
      }

      const coupon = payload && payload.coupon
      if (coupon) {
        const maxPerUser = Number(coupon.max_usage_count_per_user)
        const usageCount = Number(coupon.usage_count)
        if (maxPerUser > 0 && usageCount >= maxPerUser) {
          return 'سقف استفاده از این کد تخفیف برای شما تکمیل شده است'
        }
        if (coupon.state && coupon.state !== 'available') {
          return 'این کد تخفیف دیگر فعال نیست'
        }
      }

      if (payload && payload.can_apply_to_cart === false) {
        return 'این کد تخفیف برای سبد خرید فعلی قابل اعمال نیست'
      }

      return 'کد تخفیف معتبر نیست'
    },
    isDiscountPayloadValid(payload) {
      return payload && payload.valid === true && payload.can_apply_to_cart !== false
    },
    refreshDiscountPreview() {
      const code = (this.discount_code || '').trim()
      if (!code) return

      this.requesting('user', 'validateDiscountCode', {}, this.getDiscountRequestBody(code))
          .then((resp) => {
            const {root, payload} = this.parseDiscountApiResponse(resp)
            if (this.isDiscountPayloadValid(payload)) {
              this.discountValidation = payload
              this.discount_code = payload.discount_code || code
            } else {
              this.clearDiscount()
            }
          })
          .catch(() => {
            this.clearDiscount()
          })
    },
    openDiscountModal() {
      this.discountError = ''
      this.packageModal = true
    },
    closePackageModal() {
      if (this.packageModalLoading) return
      this.packageModal = false
      this.discountError = ''
    },
    clearDiscount() {
      this.discount_code = ''
      this.discountValidation = null
      this.discountError = ''
    },
    getPackagePriceInfo(item) {
      const currency = (item && item.currency) || 'rial'
      const original = Number(item && item.price)
      const validation = this.discountValidation
      const preview = validation && validation.preview
      const coupon = validation && validation.coupon
      const valid = validation && validation.valid === true

      if (valid && !Number.isNaN(original) && preview && preview.cart_total != null) {
        if (Number(preview.cart_total) === original) {
          return {
            hasDiscount: true,
            original,
            final: Number(preview.final_price),
            currency: preview.currency || currency,
          }
        }
      }

      if (valid && !Number.isNaN(original) && coupon) {
        const discountAmount = Number(
            preview && preview.estimated_discount != null
                ? preview.estimated_discount
                : coupon.amount_irr
        )
        if (discountAmount > 0) {
          return {
            hasDiscount: true,
            original,
            final: Math.max(0, original - discountAmount),
            currency: (preview && preview.currency) || currency,
          }
        }
      }

      return {
        hasDiscount: false,
        original,
        final: original,
        currency,
      }
    },
    confirmDiscountModal() {
      const code = (this.discount_code || '').trim()
      if (!code) {
        this.discountError = 'لطفا کد تخفیف را وارد کنید'
        return
      }

      this.packageModalLoading = true
      this.discountError = ''
      this.requesting('user', 'validateDiscountCode', {}, this.getDiscountRequestBody(code))
          .then((resp) => {
            const {root, payload} = this.parseDiscountApiResponse(resp)
            const requestOk = root.type === 'SUCCESS' || root.status_code === 200

            if (requestOk && this.isDiscountPayloadValid(payload)) {
              this.discountValidation = payload
              this.discount_code = payload.discount_code || code
              this.packageModal = false
              if (root.message) {
                this.$emitEvent('notify', {color: 'green', title: root.message})
              }
            } else if (requestOk) {
              this.discountValidation = null
              this.discountError = this.getDiscountErrorMessage(root, payload)
            } else {
              this.discountValidation = null
              this.discountError = root.message || 'خطا در بررسی کد تخفیف'
            }
          })
          .catch((err) => {
            this.discountValidation = null
            const errRoot = err?.response?.data || {}
            const errPayload = errRoot.data || errRoot
            this.discountError = this.getDiscountErrorMessage(errRoot, errPayload)
          })
          .finally(() => {
            this.packageModalLoading = false
          })
    },
    selectPackage(packageId) {
      const package_id = packageId || (this.packagesList && this.packagesList.length > 0 ? this.packagesList[0].id : 68)
      const selectedPackage = (this.packagesList || []).find((pkg) => pkg.id == package_id)
        || (this.packagesList && this.packagesList[0])
        || { id: package_id }
      const body = {
        token: localStorage.getItem('set_session_token'),
        package_id: package_id,
        discount_code: this.hasAppliedDiscount ? (this.discount_code || '').trim() : '',
      }

      this.packageModalLoading = true
      this.$emitEvent('setLoading', true)

      // Align with panel funnel: add_to_cart → begin_checkout → pay
      // GA4 dataLayer events (same style as purchase) — include journey doctor when available
      const doctorName = (this.therapist && this.therapist.user && this.therapist.user.full_name)
        || (this.therapist && this.therapist.full_name)
        || ''
      const doctorId = this.therapist && (this.therapist.id || this.therapist.user_id
        || (this.therapist.user && this.therapist.user.id))
      const funnelExtras = {
        doctor_name: doctorName,
        item_name: doctorName || (selectedPackage && selectedPackage.title) || '',
        item_id: doctorId != null ? doctorId : (selectedPackage && selectedPackage.id),
      }
      this.trackFunnelAddToCart(selectedPackage, funnelExtras)
      this.trackFunnelCheckout([selectedPackage], funnelExtras)

      this.SendEventTrk({
        event_id: 'user_journey_' + Date.now(),
        name: 'journey_pay',
        email: this.profile.email,
        first_name: this.profile.firstname,
        last_name: this.profile.lastname,
        payload: {
          package_id: package_id,
          discount_code: body.discount_code,
        }
      })
      this.requesting('setSession', 'selectPackage', {}, body).then((resp) => {

        localStorage.removeItem('set_session_token')
        localStorage.removeItem('psychology_field_id')
        localStorage.removeItem('match_additional_data')

        window.location = resp.data.payment.url.action

        // this.requesting('factor', 'payFactor', {factorID: resp.data.cart.id}).then((res) => {
        //   if (res.data.state == 'SUCCESS') {
        //     localStorage.removeItem('set_session_token')
        //     window.location = res.data.url
        //   }
        // })
      }).catch(() => {
        this.packageModalLoading = false
        this.$emitEvent('setLoading', false)
      }).finally(() => {
        // this.$emitEvent('setLoading', false)
      })
    },
  },
  filters: {

    weekDayName(dateStr) {
      momentJalali.loadPersian({dialect: 'persian-modern'});
      return momentJalali(dateStr).format("dddd");
    },
    getTime(dateStr) {
      momentJalali.loadPersian({dialect: 'persian-modern'});
      return momentJalali(dateStr).format("HH:mm");
    },
    getShortMonth(dateStr) {
      return moment(dateStr, "YYYY-MM-DD").locale('en').format("MMM");
    },
    dayNumber(dateStr) {
      return moment(dateStr, "YYYY-MM-DD").format("DD");
    },
    getDayPeriodsLabel(time) {
      console.log(time.from_time)
      const hour = parseInt(momentJalali(time.from_time).format('HH'));
      console.log(hour, '1212')
      if (hour) {
        if (hour >= 0 && hour < 12) {
          return 'صبح'
        } else if (hour >= 12 && hour < 18) {
          return 'عصر'
        } else if (hour >= 18 && hour <= 23) {
          return 'شب'
        }
      }
    },
    jalaliDateTime(value) {
      if (!value) return '';

      const m = momentJalali(value, "YYYY-MM-DD HH:mm");
      if (!m.isValid()) return value;

      return m.locale('fa').format('dddd YYYY/MM/sDD - [ساعت] hh:mm');
    },
    jalaliDateTimePartOne(value) {
      if (!value) return '';

      const m = momentJalali(value, "YYYY-MM-DD HH:mm");
      if (!m.isValid()) return value;

      return m.locale('fa').format('dddd YYYY/MM/sDD ');
    },
    jalaliDateTimePartTwo(value) {
      if (!value) return '';
      const m = momentJalali(value, "YYYY-MM-DD HH:mm");
      if (!m.isValid()) return value;
      return m.locale('fa').format(' [ساعت] hh:mm');
    },
    jalaliDateTimeWithoutLabel(value) {
      if (!value) return '';
      const m = momentJalali(value, "YYYY-MM-DD HH:mm");
      if (!m.isValid()) return value;
      return m.locale('fa').format('  hh:mm');
    },

  },
  watch: {
    packagesList(list) {
      if (list && list.length && this.discount_code && this.discountValidation) {
        this.refreshDiscountPreview()
      }
    },
    therapist: {
      immediate: true,
      deep: true,
      handler(newTherapist, oldTherapist) {
        console.log('Therapist watcher triggered:', {newTherapist, oldTherapist})
        if (newTherapist) {
          this.$nextTick(() => {
            this.tryGetPackagesByGrade()
          })
        }
      }
    }
  },
  mounted() {

    this.getFlowDetail()

    this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', 100)

    this.user = JSON.parse(JSON.stringify(this.profile))

    let times = JSON.parse(JSON.stringify(this.timezones));

    this.timezonesList = times.map((item) => {
      item.text = item.text + '  ' + moment.tz(item.text).format('Z');
      return item;
    });

    this.timezoneResultList = this.timezonesList

    // Get packages by grade if therapist is available
    console.log('Component mounted, therapist:', this.therapist)
    this.$nextTick(() => {
      this.tryGetPackagesByGrade()
    })
  },

}
</script>

<style>


@media (min-width: 200px) and (max-width: 1000px) {
  .mobileArea {
    margin-bottom: 20px;
  }

  .hintItem {
    font-size: 13px !important;
    margin-bottom: 0px !important;
  }

  .hintArea {
    padding: 16px 10px !important;
  }

  .offBadge {
    font-size: 10px !important;
  }

  .titlePackage {
    font-size: 18px !important;
  }

  .oldPrice {
    font-size: 16px !important;
  }

  .newPrice {
    font-size: 32px !important;
  }

  .perSession {
    font-size: 14px !important;
  }
}

a {
  text-decoration: none;
}

@media (min-width: 200px) and (max-width: 1000px) {
  .presessionBtn {
    margin-top: 20px;
  }

  .titlePresession {
    font-size: 16px !important;
  }
}

.presessionBtn {
  color: rgba(57, 201, 144, 1);
  border: 1px solid rgba(57, 201, 144, 1);
  border-radius: 8px;
  background: white;
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;
  padding: 10px 20px;
}

.presessionBtn:hover {
  background: rgba(0, 0, 0, 0.01);
  transition: all 0.3s;
}

.titlePresession {
  font-weight: 700;
  font-size: 20px;
}

.contentPresession {
  font-weight: 500;
  font-size: 16px;
}

.presessionBox {
  background: rgba(215, 244, 233, 0.5);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: -13px;
}


.refund {
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  margin-top: 15px;
}

.perSession {
  color: #757575;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.enFont {
}

.priceBox {
  margin-top: 24px;
}

.oldPrice {
  font-family: Roboto !important;
  color: #757575;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-decoration-line: line-through;
}

.newPrice {
  color: #424242;
  font-size: 40px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
}

.offBadge {
  border-radius: 16px;
  background: #FFECDF;
  padding: 0 12px;
  justify-content: center;
  align-items: center;
  height: 32px;
  display: flex;
  flex-direction: column;
  color: #FF852E;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.packageArea {
  margin-top: 20px;
}

.newUserPackage {
  position: relative;
  border-radius: 8px;
  border: 2px solid #39C990;
  background: #FFF;
  padding: 32px 24px 24px 24px;
}

.oldUserPackage {
  position: relative;
  border-radius: 8px;
  border: 1px solid #DBE4ED;
  background: #FFF;
  padding: 32px 24px 24px 24px;
}

.newCustomer {
  border-radius: 16px;
  background: #39C990;
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  width: 120px;
  height: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  position: absolute;
  top: -18px;
}

.titlePackage {
  color: #212121;
  text-align: right;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.hintArea {
  padding: 16px;
  border-radius: 8px;
  background: rgba(197, 239, 254, 0.20);
}

.hintItem {
  color: #212121;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
  margin-bottom: 16px;
}

.titleHintArea {
  color: #212121;
  text-align: right;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}


.submitBtn {
  border-radius: 8px;
  background: #39C990 !important;
  width: 100%;
  height: 48px !important;
  color: #FFF;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 45px;
}

.submitBtnOutline {
  border-radius: 8px;
  width: 100%;
  height: 48px !important;
  color: #FFF;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 45px;
}

.hintAreaStudent {
  color: #035184;
  font-weight: 500;
  font-size: 14px;
}

.blueHint {
  background: rgba(197, 239, 254, 0.5);
  padding: 14px 16px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(3, 81, 132, 1);
}

.blueHint__message {
  flex: 1;
  min-width: 200px;
}

.blueHint__discountBtn {
  border-color: rgba(3, 81, 132, 0.5) !important;
  color: rgba(3, 81, 132, 1) !important;
  font-weight: 700;
  background: #fff !important;
}

.blueHint__applied {
  font-size: 14px;
  color: rgba(3, 81, 132, 0.9);
}

.discount-modal-dialog {
  border-radius: 16px;
  overflow: hidden;
}

.discount-modal-sheet {
  border-radius: 20px 20px 0 0 !important;
}

.discount-modal {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
}

.discount-modal--sheet {
  border-radius: 20px 20px 0 0;
}

.discount-modal__handle {
  width: 40px;
  height: 4px;
  margin: 10px auto 0;
  border-radius: 4px;
  background: #dbe4ed;
}

.discount-modal__close {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 2;
  color: #757575 !important;
}

.discount-modal__body {
  padding: 28px 24px 24px !important;
  direction: rtl;
}

.discount-modal__header {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 24px;
}

.discount-modal__icon {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: rgba(57, 201, 144, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
}

.discount-modal__titles {
  flex: 1;
  min-width: 0;
  padding-top: 4px;
}

.discount-modal__title {
  margin: 0;
  color: #212121;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.4;
}

.discount-modal__desc {
  margin: 6px 0 0;
  color: #757575;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.6;
}

.discount-modal__input {
  margin-bottom: 8px;
}

.discount-modal__input >>> .v-input__slot {
  min-height: 52px !important;
  border-radius: 10px !important;
  background: #fafbfc !important;
}

.discount-modal__input >>> fieldset {
  border-color: #dbe4ed !important;
}

.discount-modal__input.v-input--is-focused >>> fieldset {
  border-color: #39c990 !important;
  border-width: 2px !important;
}

.discount-modal__input >>> input {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-align: center;
}

.discount-modal__actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.discount-modal__actions--stacked {
  flex-direction: column;
  gap: 8px;
}

.discount-modal__btn {
  flex: 1;
  height: 48px !important;
  border-radius: 10px !important;
  font-size: 15px !important;
  font-weight: 700 !important;
  letter-spacing: 0;
}

.discount-modal__btn--primary {
  background: #39c990 !important;
  color: #fff !important;
}

.discount-modal__btn--outline {
  border: 1.5px solid #39c990 !important;
  color: #39c990 !important;
  background: #fff !important;
}

.discount-modal__actions--stacked .discount-modal__btn--outline {
  border: none !important;
  color: #757575 !important;
  background: transparent !important;
}
</style>